import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  count: 0,
  data: null,
  list: null,
  paginator: null,
  error: null,
};

export default function NetworkingCompany(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Networking.Company.SET_COUNT:
      return { ...state, count: action.data };
    case Action.Networking.Company.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Networking.Company.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Networking.Company.CLEAR:
      return { ...state, data: {} };
    default:
      return state;
  }
}
